import { Avatar } from '@heroui/react';
import { capitalize, getFullName } from '../../utils/utils';

export const OwnerAttribution = ({ project, currentUser }) => {
  const owner = project?.owner || null;
  const ownerId = owner?.id || owner?.user_id || owner?.owner_id;
  const isOwner = ownerId && currentUser?.id ? Number(ownerId) === Number(currentUser.id) : !ownerId;
  const ownerFullName = getFullName(owner) || owner?.name || '';
  const ownerName = ownerFullName ? capitalize(ownerFullName) : '';
  const avatarSrc = owner?.profile_image || owner?.profile_image_url || owner?.avatar || null;

  return (
    <div className="px-4 pb-2 w-full flex items-center justify-end gap-2 text-xs text-white">
      <Avatar
        src={avatarSrc && typeof avatarSrc === 'string' && avatarSrc.startsWith('http') ? avatarSrc : undefined}
        showFallback
        size="sm"
        classNames={{ base: 'bg-white/20', icon: 'text-white/60' }}
      >
        {!avatarSrc && ownerName ? ownerName.charAt(0).toUpperCase() : null}
      </Avatar>
      <span>{isOwner ? 'Created by you' : `Created by ${ownerName || 'Unknown'}`}</span>
    </div>
  );
};

export default OwnerAttribution;
